import { Controller } from "@hotwired/stimulus"

// Client-side search filter for the Users table.
// Filters rows by matching name/email against the search input, combined
// with any active Role / Has Permissions / Added Date filters set by the
// sibling `staff-users-filter` controller (see staff_users_filter_controller.js).
// Each row carries two independent hidden reasons in its dataset
// (`hiddenBySearch`, `hiddenByFilter`); a row is visible only when neither is set.
export default class extends Controller {
  static targets = ["input", "row", "count", "emptyState", "tableBody", "addUserForm", "addButton"]

  connect() {
    this.filtersActive = false
    this.onFilterChanged = (event) => {
      this.filtersActive = Object.keys(event.detail?.filters || {}).length > 0
      this.refreshVisibility()
    }
    this.element.addEventListener("staff-users-filter:changed", this.onFilterChanged)
  }

  disconnect() {
    this.element.removeEventListener("staff-users-filter:changed", this.onFilterChanged)
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase()

    this.rowTargets.forEach(row => {
      const text = row.dataset.searchText || ""
      const match = text.includes(query)
      row.dataset.hiddenBySearch = match ? "" : "1"
    })

    this.refreshVisibility()
  }

  refreshVisibility() {
    let visible = 0

    this.rowTargets.forEach(row => {
      const hidden = row.dataset.hiddenBySearch === "1" || row.dataset.hiddenByFilter === "1"
      row.style.display = hidden ? "none" : ""
      if (!hidden) visible++
    })

    this.countTarget.textContent = visible

    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.toggle("hidden", visible > 0)
    }

    // Hide the table wrapper border when no results
    const tableWrapper = this.tableBodyTarget.closest(".table-border-wrapper")
    if (tableWrapper) {
      const hasQuery = this.inputTarget.value.length > 0
      tableWrapper.classList.toggle("hidden", visible === 0 && (hasQuery || this.filtersActive))
    }
  }

  toggleAddUser() {
    const form = this.addUserFormTarget
    const isHidden = form.classList.contains("hidden")
    form.classList.toggle("hidden")

    if (isHidden) {
      // Focus the first input
      const firstInput = form.querySelector("input[type=text]")
      if (firstInput) firstInput.focus()
    }
  }
}
